import React from "react";
import "./footer.css";
import { AiFillLinkedin } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";

const footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Rahul R Yadav
      </a>

      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#skills">Skills</a>
        </li>
        <li>
          <a href="#coding skills">Coding Skills</a>
        </li>
        <li>
          <a href="#portfolio">Projects</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/rahul-r-yadav-3772ba1b4/"
          target={"_blank"}
          rel="noreferrer"
        >
          <AiFillLinkedin />
        </a>
        <a
          href="https://github.com/raahul131"
          target={"_blank"}
          rel="noreferrer"
        >
          <BsGithub />
        </a>
        <a
          href="https://twitter.com/rahuly131"
          target="_blank"
          rel="noreferrer"
        >
          <BsTwitter />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; {new Date().getFullYear()}, All rights reserved.</small>
      </div>
    </footer>
  );
};

export default footer;
